__turbopack_context__.v({
  "button": "ViewDetailsButton-module-scss-module__j4OliG__button",
  "container": "ViewDetailsButton-module-scss-module__j4OliG__container",
});
